<template>
  <section id="hero">
    <span class="trace">SplashWQ.vue</span>
    <!--
        :src="require(`@/assets/project-waterQuality.jpg`)"
          gradient="350deg, rgba(5, 11, 31, .8) , rgba(5, 11, 131, .6)"
    -->
    <v-img
      :src="require(`@/assets/images/water/water-testing-website-2nd-pic.jpg`)"
      class="white--text"
      gradient="350deg, rgba(5, 11, 31, .8) , rgba(5, 11, 81, .8)"
    >
      <v-container class="fill-height px-4 py-0">
        <div class="ml-6 mr-3">
        <!--
          <toolbar-wq />
        -->
          <h1>Private Wells and Truro Safe Water<br></h1>
          <!--
          :min-height="minHeight"
          gradient="65deg, rgba(5, 11, 31, .9) , rgba(5, 11, 31, .6) 50%, rgba(5, 11, 31, .1)"
          <base-img
            :height="$vuetify.breakpoint.mdAndUp ? 499 : 250"
            :src="require(`@/assets/project-waterQuality.jpg`)"
            class="mb-6 mb-md-12"
          />
          -->
          <h4>Abstract</h4>
          <p>
            This paper reviews and presents a compilation of 75 years of
            scientific research collected on private well water and its safety. It
            has been undertaken by the <em>Docs for Truro Safe Water</em> group to
            present and highlight the scientific evidence available to residents
            and Town decision makers who are concerned with drinking water
            safety in a variety of settings. Where current standards rely on
            geo-specific and/or historic data, particular consideration has been
            given to circumstances particular to the Outer Cape, as well as to
            research that has appeared in past two decades.
          </p>

          <p>
            The paper was recently made available and can be viewed at these links:
            <ul>
                <li>
            <a
              href="https://www.dropbox.com/s/8sqmgdl9br2vs84/Exec%20Summary_PrivateWellsInTruro_09-06-20.pdf?dl=0"
              target="_blank"
            >
              Executive Summary</a> <small>(0.17 MB)</small>
                </li>
                <li>
            <a
              href="https://www.dropbox.com/s/8sqmgdl9br2vs84/Exec%20Summary_PrivateWellsInTruro_09-06-20.pdf?dl=0"
              target="_blank"
            >
              Full Report</a> <small>(including Executive Summary: __ MB)</small>
                </li>
            </ul>
          </p>

          <p>
            Authors, Reviewers and Researchers:
            <ul>
                <li>
            <a
              href="https://www.researchgate.net/figure/Location-of-the-four-flow-lenses-of-the-Lower-Cape-Cod-aquifer-system-and_fig1_265182427"
              target="_blank"
            >
              Docs for Truro Safe Water
            </a>
                </li>
                <!--
                <li>
            <a
              href="https://www.researchgate.net/figure/Location-of-the-four-flow-lenses-of-the-Lower-Cape-Cod-aquifer-system-and_fig1_265182427"
              target="_blank"
            >
              Full Report
            </a>
                </li>
                -->
            </ul>
          </p>

          <!--
          <p>
            Did you know that all of our drinking water comes from one source, a
            <a
              href="https://www.researchgate.net/figure/Location-of-the-four-flow-lenses-of-the-Lower-Cape-Cod-aquifer-system-and_fig1_265182427"
              target="_blank"
            >
              lens
            </a>, a communal aquifer that is like an underground pond, that is relatively small, floating not that far under our homes, gardens, septic systems, roads and yes, under Route 6?  Unlike most cities that typically run their public consumption water through a water treatment plant, Truro’s water quality is mostly untreated, directly related to the condition of the aquifer water beneath us. The water we pump up from our revered private wells is a reflection of what we’ve put into the ground either directly or through our septic systems.  While it may be romantic to a degree to have our own private wells, it does pose certain problems with respect to quality control.  A number of hydrologists have raised concerns about the contaminants that are increasingly showing up in water analysis tests done from private wells in Truro. Where is this all coming from, and what can we do about it?
          </p>
          <p>
            We can’t help but wonder if the situation is already tentative, what will happen if we don’t act now, what will our water look like down the road for our kids, our families and grandkids.  We might ask ourselves, is there any other single element that we put into our bodies that is as important as water? We think not.
          </p>
          <p>
            So, we might also be wondering, <a
            href="https://www.truro-ma.gov/sites/g/files/vyhlif3936/f/u286/wastewater_in_truro_august_13_2015.pdf"
            target="_blank"
            >where is all of this contamination coming from</a>, and what can we do to straighten this mess out? With this concern in mind, a group of Truro residents has taken charge to bring the situation to the attention of all those living in Truro. We call ourselves the Truro Water Protectors. Our aim is to clean up our dirty water!
          </p>
          <p>
            Fortunately, there are solid ways to fix this mess, through both <b>mitigation</b> and <b>adaptation</b>. When we talk about mitigation we are referring to steps taken in order to slow down the contamination trend. This is key because in so doing the benefits are twofold: we protect ourselves and we protect our neighbors, our children, our tenants and our friends from what could be serious health issues from chemicals contaminating our drinking water. At this time in our history we can no longer think of ourselves as separate entities when it comes to the drinking water that we all share here in Truro. There are no fences underground.  Where water is concerned, the fact is, we are all one.  We cannot afford to ignore this interdependence.
          </p>
          <p>
            When we talk about adaptation we are referring to steps that we can take individually to adapt to the existing situation. This would be to safeguard our own health, but not necessarily improve the communal water quality. It’s a temporary fix.
          </p>
          <p>
            With both these strategies in mind, The Water Protectors are firmly committed to guiding us in improving the water quality in Truro. We absolutely must do this.
          </p>
          <p>
            Bearing in mind the seriousness of this ,
            <v-btn
              small
              text
              class="mr-2 small more"
              color="primary"
              @click="situationClick"
            >
              situation
            </v-btn>
            we therefore invite all interested Truro residents to join in our efforts, and to also become Truro Water Protectors, doing whatever time permits to help. Please read about the projects that are now underway on our website here. Our goal is to offer both mitigation and adaptation solutions that are relatively easy and cost effective.  Believe it or not, just by changing a few basic daily habits we could potentially see some significant changes in the quality of our drinking water!
          </p>
          <p>
            We hope that you will be inspired to jump in, helping us create a healthy change for all.
          </p>
          <p>
            May Truro remain our unique paradise.
          </p>
          -->
        </div>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {

    components: {
      ToolbarWq: () => import('@/views/projects/ToolbarWq'),
    },

    name: 'splashWQ',

    methods: {
      situationClick: function (event) {
        this.$router.push({ name: 'Health' })
      },

    },

  }
</script>

<style>
  .more {
    color: red;
    font-style: bold;
  }
</style>
